import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"

// redux
import { SliceName } from "./slice.types"

export type BaseState = {
  langCode: string
  hasAttemptedLogin: boolean
  isLoadingResults: boolean
  caseNumber: string
  caseId: string
  audienceEnglishCategory:
    | "Homepage variation: Attendee"
    | "Homepage variation: Organizer"
  cxoneReady: boolean
  niceChatIsLive: boolean
  niceChatWindowOpened: boolean
  niceChatHasConcluded: boolean
  showLiveChatGlobal: boolean
  allLiveSupportIsTemporarilyDisabled: boolean
  chatbotApiCallsCompleted: boolean
  shouldShowAIChatbot: boolean
  shouldPollUserMetadata: boolean
  decagonLoadedEventFired: boolean
  chatbotFirstExperiment: boolean
}

const initialState: BaseState = {
  langCode: "",
  hasAttemptedLogin: false,
  isLoadingResults: false,
  caseNumber: "",
  caseId: "",
  audienceEnglishCategory: "Homepage variation: Attendee",
  cxoneReady: false,
  niceChatWindowOpened: false,
  niceChatIsLive: false,
  niceChatHasConcluded: false,
  showLiveChatGlobal: false,
  allLiveSupportIsTemporarilyDisabled: false,
  chatbotApiCallsCompleted: false,
  shouldShowAIChatbot: true,
  shouldPollUserMetadata: false,
  decagonLoadedEventFired: false,
  chatbotFirstExperiment: false
}

export const metaDataSlice = createSlice({
  name: SliceName.metaData,
  initialState,
  reducers: {
    setMetaData: (s, action: PayloadAction<Partial<BaseState>>) => {
      return { ...s, ...action.payload }
    }
  }
})

export const { setMetaData } = metaDataSlice.actions

export const metaDataReducer = metaDataSlice.reducer
